import DialogStudentNotification from "../DialogStudentNotification";

const DialogAddStudentError = ({
	dialog
}) => {
	return (
		<DialogStudentNotification
			dialog={dialog}
			title="Ocurrió un error inesperado al agregar los alumnos"
			description={dialog.description}
			students={dialog.studentsWithErrors}/>
	);
}

export default DialogAddStudentError;